import {get} from './request';

/**
 * @typedef City
 * @prop {string} ID
 * @prop {string} CODE
 * @prop {string} CITY_NAME
 * @prop {string | null} REGION_NAME": null,
 * @prop {string} id
 * @prop {string} text
 * @prop {string | null} region
 */

/**
 *
 * @param {string} query
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<City[]>}
 */
export default function searchCity(query, config) {
    return get(`/api/Location/getCities/`, config, new URLSearchParams({
        q: query,
    }));
}
